import React, { useEffect } from "react";
import Header from "../landing/Header/Header";
import Footer from "../landing/footer/Footer";
import "./support.scss";
import Sidebar from "./Sidebar";
import { useParams } from "react-router-dom";
import Chatandpayment from "./Chatandpayment";
import Welcome from "./Welcome";
import Whatwedo from "./Whatwedo";
import Ourfeatures from "./Ourfeatures";
import Gettingstarted from "./Gettingstarted";

const Support = () => {

  const { section } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [section]);
  const renderContent = () => {
    switch (section) {
      case "welcome":
        return (
          <div>
            <Welcome />
          </div>
        );
      case "whatwedo":
        return (
          <div>
            <Whatwedo />
          </div>
        );
        case "ourfeatures":
            return (
              <div>
                <Ourfeatures />
              </div>
            );
            case "gettingstarted":
                return (
                  <div>
                    <Gettingstarted />
                  </div>
                );
      case "chatandpayments":
        return (
          <div>
            <Chatandpayment />
          </div>
        );

      default:
        return (
          <div>
            <Welcome />
          </div>
        );
    }
  };

  return (
    <>
      <Header />
      <section className="supportmain">
        <div className="app">
          <Sidebar />
          <div className="content">{renderContent()}</div>
          <img
            src="/assets/supportimg.png"
            alt="supportimg"
            className="supportimg"
          />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Support;
